import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';
import lang from './modules/lang';
import auth from './modules/auth';
import toast from 'resonance-theme/src/vue/store/toast';
import network from './modules/network';
import meeting from './modules/meeting';
import notifications from './modules/notifications';
import notificationUI from './modules/notificationUI';
import content_language from './modules/content_language';
import feed from './modules/feed';
import course_feed from './modules/course_feed';
import brand from './modules/brand';

let persistedStores = [
    'lang',
    'auth',
    'network',
    'meeting',
    // 'notifications',
    'content_language',
    'feed', // feed filter
    'course_feed', // course feed filter
    'cookiePolicyAccepted',
    'currentBrand',
    'brand',
];

const persistedState = createPersistedState({
    paths: persistedStores,
});

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
    strict: debug,

    plugins: [persistedState],

    modules: {
        lang,
        auth,
        toast,
        network,
        meeting,
        notifications,
        notificationUI,
        content_language,
        feed,
        course_feed,
        brand,
    },

    state: {
        maintenance: null,
        validationErrors: '',
        cookiePolicyAccepted: true,
        currentBrand: null,
    },

    getters: {
        cookiePolicy(state) {
            return state.cookiePolicyAccepted;
        },
        currentBrand(state) {
            return state.currentBrand;
        },
    },

    mutations: {
        setCookiePolicy(state, n) {
            state.cookiePolicyAccepted = n;
        },
        setCurrentBrand(state, n) {
            state.currentBrand = n;
        },
        maintenance(state, payload) {
            if (state.maintenance == null) state.maintenance = payload;
        },
        validationErrors(state, payload) {
            if (state.validationErrors === '') state.validationErrors = payload;
        },
    },
    actions: {
        clearPersistedStates({ commit }) {
            persistedStores.forEach(s => {
                let ignoreState = ['cookiePolicyAccepted', 'currentBrand'];
                if (s == 'auth') {
                    commit('RESET_STATE');
                } else {
                    if (!ignoreState.includes(s)) {
                        commit(s + '/RESET_STATE');
                    }
                }
            });
        },
    },
});

export default store;
